import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import React from 'react';
import { useSelector } from 'react-redux';

const useStyles = makeStyles(theme => ({
  root: {
    '& .logo-icon': {
      width: 24,
      height: 24,
      transition: theme.transitions.create(['width', 'height'], {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      })
    },
    '& .react-badge, & .logo-text': {
      transition: theme.transitions.create('opacity', {
        duration: theme.transitions.duration.shortest,
        easing: theme.transitions.easing.easeInOut
      })
    }
  },
  logo: {
    height: 22
  }
}));

function Logo() {
  const classes = useStyles();
  const user = useSelector(({ auth }) => auth.user);

  const getSrc = () => {
    return user && user.hairdresserSelected && user.hairdresserSelected.brand
      ? `/assets/images/logos/${user.hairdresserSelected.brand.code}.svg`
      : 'assets/images/logos/logo.png';
  };

  return (
    <div className={clsx(classes.root, 'flex items-center')}>
      <div className="flex items-center ml-2 mr-8 mt-1 py-4">
        <img className={clsx(classes.logo)} src={getSrc()} alt="logo" />
      </div>
    </div>
  );
}

export default Logo;
